<template>
  <div>
    <modalDefaultBig :showModal="showModal" @close="close()" @confirm="confirm()" modalText="恭喜获得" :showCancel="false"
      :showConfirm="false">
      <template #dialogContent>
        <div class="skinsInfo">
          <div class="list-inner" :class="'list-inner-' + num">
            <template v-if="boxType == 'openBox'">
              <div :class="getColor(item.ornamentsLevelId)" class="prod-info" v-for="(item, index) in skinsInfo"
                :key="index">
                <div class="img-box flex-center">
                  <img :src="$getFullPath(item.imageUrl)" class="img" mode="aspectFit" />
                </div>
                <div class="info-box">
                  <div class="info-aw" :style="{ fontSize: skinsInfo.length > 1 ? '10px' : '14px' }">{{ item.exteriorName
                  || "" }}</div>
                <div class="info-name text-ellipsis" :style="{ fontSize: skinsInfo.length > 1 ? '9px' : '10px' }">
                  {{ item.shortName || item.ornamentName }}
                </div>
                <div class="info-price flex-center">
                  <img src="@/assets/home/jinbi.png" class="coin" />
                  <span style="margin-left: 5px;">{{ item.usePrice || item.ornamentsPrice }}</span>
                </div>
                </div>
              
              </div>
            </template>
            <template v-if="boxType == 'luckyBox'">
              <div :class="getColor(skinsInfo.ornamentLevel)" class="prod-info">
                <div class="img-box flex-center">
                  <img :src="$getFullPath(skinsInfo.ornamentImgUrl)" class="img" mode="aspectFit" />
                </div>
                <!-- <div class="info-aw">{{ item.exteriorName }}</div> -->
                <div class="info-name text-ellipsis">
                  {{ skinsInfo.ornamentName }}
                </div>
                <div class="info-price flex-center">
                  <img src="../../assets/images/balance2.png" class="coin" />
                  <span>{{ skinsInfo.ornamentPrice }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template #customBtn>
        <div class="btn-group">
          <div class="btn-cancel opt-btn" @click="close">放入背包</div>
          <div class="btn-confirm opt-btn" @click="exchangeToMoney" :class="{ 'disabled': isExchanging }">
            <img style="width: 20px; height: 20px;margin-right: 5px;" src="@/assets/home/jinbi.png" />
            {{ getTotalPrice().toFixed(2) }}
            {{ isExchanging ? '分解中...' : '分解' }}
          </div>
        </div>
      </template>
    </modalDefaultBig>
  </div>
</template>
<script>
import { decompose, getUserInfo } from "@/api/index";
import modalDefaultBig from "@/components/common/modalDefaultBig.vue";
export default {
  name: "modalBoxResult",
  components: {
    modalDefaultBig,
  },
  data() {
    return {
      msg: "",
      isExchanging: false, // 防抖标志
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    skinsInfo: {
      type: Array | Object,
      default: false,
    },
    num: {
      type: Number,
      default: 1,
    },
    boxType: {
      type: String,
      default: "openBox",
    },
  },
  watch: {
    showModal(newValue, oldValue) {
      if (newValue) {
        // this.user = uni.getStorageSync("userInfo");
        // this.$nextTick(() => {
        //   this.$refs.dialog.open();
        //   this.msg = "";
        // });
      }
    },
  },
  methods: {
    getTotalPrice() {
      if (this.boxType == "openBox") {

        const prices = Object.values(this.skinsInfo).map(
          (item) => item.usePrice || item.ornamentsPrice
        );
        return prices.reduce((acc, price) => acc + price, 0);
      } else {
        return this.skinsInfo.ornamentPrice;
      }
    },
    exchangeToMoney() {
      // 防抖处理，防止重复点击
      if (this.isExchanging) {
        return;
      }
      this.isExchanging = true;

      // 提取饰品列表里面的id
      let skinsIdList = [];
      if (this.boxType == "openBox") {
        skinsIdList = this.skinsInfo.map((item) => item.id);
      }else if(this.boxType == "luckyBox"){
        skinsIdList = this.skinsInfo.boxRecordIds;
        if(this.skinsInfo.ornamentId == '697345536'){
          this.$message({
            duration: 1000,
            message: '该饰品不可分解',
            type: "error",
            customClass: "log_error",
          });
          this.isExchanging = false; // 重置防抖标志
          return
        }
      }
      // 调用接口
      decompose({ isAll: false, packSackIds: skinsIdList }).then((res) => {
        if (res.data.code == 200) {
          getUserInfo().then((res) => {
            this.user = res.data.data;
            this.$store.commit("USER_INFO", res.data.data);
          });
          this.$message({
            duration: 1000,
            message: res.data.data,
            type: "success",
            customClass: "log_success",
          });
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "error",
            customClass: "log_error",
          });
        }
        this.close();
      }).catch((error) => {
        // 处理请求错误
        this.$message({
          duration: 1000,
          message: '请求失败，请重试',
          type: "error",
          customClass: "log_error",
        });
        console.error('分解请求失败:', error);
      }).finally(() => {
        // 无论成功失败都重置防抖标志
        this.isExchanging = false;
      });
    },
    close() {
      // 重置防抖标志
      this.isExchanging = false;
      this.$emit("close");
    },
    getColor(color) {
      if (color == "1" || color == "金色") {
        return "golden";
      }
      if (color == "2" || color == "红色") {
        return "red";
      }
      if (color == "3" || color == "紫色") {
        return "purple";
      }
      if (color == "4" || color == "蓝色") {
        return "blue";
      }
    },
  },
};
</script>

<style scoped lang="scss">
// .consume-reward {
//   width: 100%;
//   padding: 10.67 * 4.2px 10.67 * 4.2px 0 13.33 * 4.2px;
//   height: 112.13 * 4.2px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   background: url("../../assets/images/k33.png") no-repeat 7.07 * 4.2px 7.07 *
//     4.2px;
//   background-size: 85.87 * 4.2px 104.27 * 4.2px;
// }

// .consume-reward .top-total-box {
//   width: 73.87 * 4.2px;
//   height: 5.47 * 4.2px;
//   background: url("../../assets/images/text_bg.png") no-repeat -6.67 * 4.2px 0;
//   background-size: 73.87 * 4.2px 5.47 * 4.2px;
//   padding-left: 1.73 * 4.2px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   font-size: 3.47 * 4.2px;
//   white-space: nowrap;
//   color: #b4c5ff;
// }

// .consume-reward .top-total-box div {
//   padding-bottom: 2.67 * 4.2px;
// }

// .consume-reward .top-total-box .price {
//   color: #eec88b;
// }

// .consume-reward .top-total-box .vip {
//   font-size: 4.4 * 4.2px;
//   color: #eec88b;
// }

// .consume-reward .top-total-box .total-box-1 {
//   width: 37.33 * 4.2px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//   -ms-flex-align: center;
//   align-items: center;
// }

// .consume-reward .top-total-box .total-box-2 {
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//   -ms-flex-align: center;
//   align-items: center;
// }

// .consume-reward .top-total-box .total-box-2 image {
//   margin-top: -0.67 * 4.2px;
//   margin-right: 1.33 * 4.2px;
//   width: 12 * 4.2px;
//   height: 4.67 * 4.2px;
// }

// .consume-reward .top-total-box .total-box-2 .percent {
//   color: #48e538;
// }

// .consume-reward .reward-box {
//   width: 73.87 * 4.2px;
//   height: 20.4 * 4.2px;
//   background: url("../../assets/images/box_bg.png") no-repeat 0 0;
//   background-size: 73.87 * 4.2px 20.4 * 4.2px;
//   margin-top: 4.67 * 4.2px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: vertical;
//   -webkit-box-direction: normal;
//   -webkit-flex-direction: column;
//   -ms-flex-direction: column;
//   flex-direction: column;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//   -ms-flex-align: center;
//   align-items: center;
//   -webkit-box-pack: center;
//   -webkit-justify-content: center;
//   -ms-flex-pack: center;
//   justify-content: center;
// }

// .consume-reward .reward-box .reward-price {
//   font-family: "Alimama ShuHeiTi", serif;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-align: center;
//   -webkit-align-items: center;
//   -ms-flex-align: center;
//   align-items: center;
//   color: #eec88b;
//   font-size: 8.93 * 4.2px;
// }

// .consume-reward .reward-box .reward-price .bi {
//   width: 5.6 * 4.2px;
//   height: 5.07 * 4.2px;
//   margin-right: 2.27 * 4.2px;
// }

// .consume-reward .reward-box .time {
//   font-size: 2.67 * 4.2px;
//   color: #6f87a5;
// }

// .consume-reward .last-date-reward {
//   width: 100%;
//   height: 4 * 4.2px;
//   font-size: 3.33 * 4.2px;
//   padding-top: 4.53 * 4.2px;
// }

// .consume-reward .last-date-reward .price {
//   color: #eec88b;
// }

// .consume-reward .rule-desc-box {
//   width: 73.87 * 4.2px;
//   padding-top: 7.33 * 4.2px;
//   padding-bottom: 2.67 * 4.2px;
// }

// .consume-reward .rule-desc-box .rule-title {
//   width: 100%;
//   height: 7.47 * 4.2px;
//   background: url("../../assets/images/line10.png") no-repeat 0 bottom;
//   background-size: 100% 1px;
//   padding-left: 1.6 * 4.2px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   font-size: 4.4 * 4.2px;
// }

// .consume-reward .rule-desc-box .rule-text {
//   padding: 2.67 * 4.2px 3.33 * 4.2px 1.33 * 4.2px;
//   margin-top: 2.67 * 4.2px;
//   font-size: 3.2 * 4.2px;
//   background: url("../../assets/images/k34.png") no-repeat;
//   background-size: 100% 100%;
// }

// .consume-reward .rule-desc-box .rule-text p {
//   margin-bottom: 2.53 * 4.2px;
// }

// .consume-reward .bottom-tip-box {
//   width: 100%;
//   height: 6.67 * 4.2px;
//   display: -webkit-box;
//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   font-size: 3.33 * 4.2px;
//   color: #6796f6;
//   padding-top: 1.87 * 4.2px;
// }

// .consume-reward .bottom-tip-box .desc-img {
//   width: 6.53 * 4.2px;
//   height: 6.67 * 4.2px;
//   margin-left: 2.53 * 4.2px;
// }

// .consume-reward .vip-detail-dialog .van-dialog {
//   padding-top: 13.33 * 4.2px;
// }
// .consume-reward {

// }

.consume-reward .vip-detail-dialog .bottom-btn-wrap {
  width: 100%;
  height: auto;
  padding-bottom: 8 * 4.2px;
  padding-top: 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.opt-btn {
  width: 38 * 4.2px;
  height: 8.13 * 4.2px;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 38 * 4.2px 8.13 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.opt-btn text {
  margin-top: 0.53 * 4.2px;
}

.opt-btn.red {
  background-image: url("../../assets/images/del_confirm_btn.png");
}

.opt-btn.btn-2 {
  width: 29.27 * 4.2px;
  height: 10.67 * 4.2px;
  background-size: 29.27 * 4.2px 10.67 * 4.2px;
  font-size: 4 * 4.2px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
}

.list-inner-1, .list-inner-5{
  .prod-info {
    width: 68.81 * 4.2px !important;
    height: 19.33 * 4.2px * 2.5 !important;

    .img-box {
      width: 100% !important;
      height: 100% !important;

      .img {
        width: 60% !important;
        height: 60% !important;
      }
    }

    .info-aw {
      font-weight: 500 !important;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi !important;
      font-size: 14px !important;
      padding: 0 0 0 1.33 * 4.2px * 2.5 !important;
      bottom: 4 * 4.2px * 1.7 !important;
    }

    .info-name {
      font-weight: 400 !important;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi !important;
      bottom: 0.8 * 4.2px * 2 !important;
      font-size: 2.86 * 4.2px !important;
      padding: 0 0 0 1.33 * 4.2px * 2.5 !important;
    }

    .info-price {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi !important;
      font-weight: 500 !important;
      font-size: 3.33 * 4.2px !important;
      right: 1.6 * 4.2px * 2.5 !important;
      height: 4.27 * 4.2px * 2.1 !important;
      line-height: 4.27 * 4.2px * 2.1 !important;
      bottom: 0.8 * 4.2px * 1.1 !important;
    }

    // .coin {
    //   width: 3.57 * 4.2px !important;
    //   height: 3.57 * 4.2px !important;
    // }
  }
}

// .list-inner-2,
// .list-inner-3,
// .list-inner-4 {
//   .prod-info {
//     width: 34 * 4.2px !important;
//     height: 35.06 * 4.2px !important;
//   }

//   .img-box {
//     width: 70% !important;
//     height: 35.06 * 4.2px !important;
//     margin: 0 auto;
//   }

//   .info-aw {
//     bottom: 4 * 4.2px * 1.3 !important;
//   }

//   .info-name {
//     bottom: 0.8 * 4.2px * 1.3 !important;
//   }

//   .info-price {
//     bottom: 0.8 * 4.2px * 1.2 !important;
//   }
// }

.dialog-footer {
  height: 16.8 * 4.2px !important;
}

.skinsInfo {
  .list-inner {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: flex-start;
    -ms-flex-line-pack: start;
    height: 55.48 * 4.2px;
    overflow-y: scroll;
    padding: 2.67 * 4.2px 0 0 0px;
    color: #fff;
    align-content: center;
    justify-content: center;
  }

  .prod-info {
    position: relative;
    width: 68.81 * 4.2px;
    height: 25.87 * 4.2px;
    background-size: 100% 100%;
    // background-image: url("../../assets/images/item_blue2.png");
    background-image: url("../../assets/image3/home/prizeDraw.png");
    margin: 15px auto 0;
  }

  .prod-info.golden {
    // background-image: url("../../assets/images/item_golden2.png");
    background-image: url("../../assets/image3/home/prizeDraw.png");
  }

  .prod-info.red {
    // background-image: url("../../assets/images/item_red2.png");
    background-image: url("../../assets/image3/home/prizeDraw.png");
  }

  .prod-info.purple {
    // background-image: url("../../assets/images/item_purple2.png");
    background-image: url("../../assets/image3/home/prizeDraw.png");
  }

  .prod-info.blue {
    // background-image: url("../../assets/images/item_blue2.png");
    background-image: url("../../assets/image3/home/prizeDraw.png");
  }

  .prod-info .img-box {
    width: 28.13 * 4.2px;
    height: 19.33 * 4.2px;
  }

  .prod-info .img-box .img {
    width: 90%;
    height: 90%;
    margin-top: -8%;
    -o-object-fit: scale-down;
    object-fit: scale-down;
  }

  .prod-info .info-aw {
    position: absolute;
    bottom: 4 * 4.2px;
    left: 0;
    font-size: 14px;
    font-weight: 500;
    padding: 0 0 0 1.33 * 4.2px;
  }

  .prod-info .info-name {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    bottom: 0.8 * 4.2px;
    left: 0;
    width: 60%;
    height: 4.27 * 4.2px;
    line-height: 4.27 * 4.2px;
    padding: 0 1.33 * 4.2px;
    font-size: 2.86 * 4.2px;
    text-align: left;
    font-weight: 400;
  }

  .prod-info .info-price {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 3.33 * 4.2px;
    position: absolute;
    bottom: 0.8 * 4.2px;
    right: 1.6 * 4.2px;
    height: 4.27 * 4.2px;
    line-height: 4.27 * 4.2px;
    color: #ffe2c0;
  }

  .prod-info .info-price .coin {
   width: 1.5rem;
   height: 1.5rem;
  }
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  width: 100%;

  .btn-cancel,
  .btn-confirm {
    width: 38 * 4.2px;
    height: 8.13 * 4.2px;
    line-height: 8.13 * 4.2px * 1.2;
    font-size: 4 * 4.2px * 0.8;
    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
    color: #fff;
    background-size: 38 * 4.2px 8.13 * 4.2px
  }

  .btn-confirm {
    width: 150px;
    background-size: 100% 100% !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .btn-cancel {
    background: url("../../assets/image3/home/backpackBtn.png") no-repeat 0 0 !important;
    background-size: 38 * 4.2px 8.13 * 4.2px !important;
  }

  .btn-confirm.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}

/deep/.dialog-big {
  height: 550px !important;
}

.skinsInfo {
  height: 342px;
  overflow-y: scroll;
}

.skinsInfo .list-inner {
  align-content: flex-start;
}

@media only screen and (max-width: 430px) {
  // .skinsInfo {
  //   height: 100vw;
  // }
}
.info-box {
  width: 100%;
  height: 3.3rem;
  background: #0B0D37;
  position: absolute;
  left: 0;
  bottom: 0rem;
  padding: 0.4rem;
  box-sizing: border-box;
}
</style>